import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=1415e13d&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=1415e13d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1415e13d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1415e13d')) {
      api.createRecord('1415e13d', component.options)
    } else {
      api.reload('1415e13d', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=1415e13d&scoped=true", function () {
      api.rerender('1415e13d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/announcements/AddLetter/Main.vue"
export default component.exports